/* eslint-disable require-jsdoc */
import { debug } from '../../../../../config';
import {defaultImg} from '../../../utils/defaultImg';
import {getVenueImage, getVenueContactHtml} from './venueLogic';
import {getVenueSocial, hasVenueSocial} from './venueSocial';
// import { renderMap } from '../../map/gMap';
function getVenueHtml(venue, popUpObj) {
  debug && console.log('in get venue html popupobj ', popUpObj);
  const venueName = venue.venueName;
  const venueImage = getVenueImage(venue.venueImage);
  const venueContact = getVenueContactHtml(venue);
  const venueDescription = venue.description;
  const venueSocial = hasVenueSocial(venue) ? getVenueSocial(venue) : '';

  return ` <section class="hearby-section-playingat">
                   <div class="hearby-details-row">
                      <div class="hearby-col hearby-col-100">
                         <h2>
                            <span class="hearby-title-subhead">Playing at</span>
                            <span class="hearby-mainhead">${venueName}</span>
                         </h2>
                      </div>
                   </div>
                </section>
                <section class="hearby-section-eventvenuedetails">
                   <div class="hearby-details-row">
                      <div class="hearby-col hearby-col-50">
                         <img src="${venueImage}" 
                         class="hearby-venue-details-image"
                          alt="" srcset="
                          ${venueImage} 408w,
                          ${venueImage} 300w
                            " sizes="(max-width: 408px) 100vw, 408px"
                            onerror="this.onerror=null;
                            this.src='${defaultImg()}';"/>
                      </div>
                      <div class="hearby-col hearby-col-50">
                         <div class="hearby-eventvenuedetails-content">
                            <div class="hearby-event-venue-summary">
                               <p>
                                  ${venueDescription}
                               </p>
                            </div>
                            ${venueContact}
                            ${venueSocial}
                         </div>
                      </div>
                   </div>
                   <div class="hearby-details-row">
                      <div class="hearby-col hearby-col-100">
                         <div class="hearby-map-popup-${popUpObj.widgetID}"
                         style="width: 100%; height: 100%; min-height: 50em;"
                         data-lat="${venue.lat}"
                         data-lng="${venue.lng}"
                         data-address="${venue.address}"
                        data-title="${venue.venueName}"></div>
                      </div>
                   </div>
                </section>`;
}
export {getVenueHtml};
